import { render } from "./PraticeOtto.vue?vue&type=template&id=77fc278f&scoped=true&ts=true"
import script from "./PraticeOtto.vue?vue&type=script&lang=ts"
export * from "./PraticeOtto.vue?vue&type=script&lang=ts"

import "./PraticeOtto.vue?vue&type=style&index=0&id=77fc278f&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fc278f"]])

export default __exports__